; (function () {
  const mapWrapper = document.querySelector(".map-wrapper");
  if (!mapWrapper) return;

  const getPosition = (lat, lng) => {
    const { boundingLeft, boundingBottom, boundingRight, boundingTop } = mapWrapper.dataset;

    return {
      x: ((lng - boundingLeft) / (boundingRight - boundingLeft) * 100),
      y: ((lat - boundingBottom) / (boundingTop - boundingBottom) * 100)
    }
  };

  const setActive = (city) => {
    document.querySelector(`.pin[data-city="${city}"]`).classList.add('active');
    const button = document.querySelector(`.city[data-city="${city}"]`);
    button.classList.add('btn-black');
    button.classList.remove('btn-grey-light');
  }

  const setInactive = (city) => {
    document.querySelector(`.pin[data-city="${city}"]`).classList.remove('active');
    const button = document.querySelector(`.city[data-city="${city}"]`);
    button.classList.add('btn-grey-light');
    button.classList.remove('btn-black');
  }

  const citiesButtons = document.querySelectorAll('.store-locations .city[data-city]');
  if (!citiesButtons) return;

  const pin = document.querySelector('.map-pins .pin');
  if (!pin) return;

  const mapPinsWrapper = document.querySelector('.map-pins');
  if (!mapPinsWrapper) return;

  citiesButtons.forEach(citiesButton => {
    const { lat, lng, city } = citiesButton.dataset;

    const { x, y } = getPosition(parseFloat(lat), parseFloat(lng));

    const clonedPin = pin.cloneNode(true);
    clonedPin.style.left = `${x}%`;
    clonedPin.style.bottom = `${y}%`;
    clonedPin.dataset.city = city;
    clonedPin.style.display = 'flex';

    clonedPin.addEventListener('mouseenter', (e) => setActive(e.target.dataset.city));
    clonedPin.addEventListener('mouseleave', (e) => setInactive(e.target.dataset.city));

    mapPinsWrapper.appendChild(clonedPin);

    citiesButton.addEventListener('mouseenter', (e) => setActive(e.target.dataset.city));
    citiesButton.addEventListener('mouseleave', (e) => setInactive(e.target.dataset.city));
  });

})();
